import { createI18n } from 'vue-i18n'
import en from './locales/en'
import ptBR from './locales/pt-BR'

const i18n = createI18n({
  legacy: false,
  locale: 'pt-BR',
  fallbackLocale: 'pt-BR',
  messages: {
    'pt-BR': ptBR,
    en,
  },
})

export default i18n

/**
 * Shorthand for non-component contexts (services, stores).
 * Inside Vue components, prefer `useI18n()` composable instead.
 */
export function t(key: string, params?: Record<string, unknown>): string {
  return (i18n.global as any).t(key, params ?? {})
}
